// extracted by mini-css-extract-plugin
export default {"root":"_3rz-yaI0","content":"_1x9khfTq"};